import {
  TableView
} from "@tiptap/extension-table";

import {
  Table
} from "@tiptap/extension-table/table";


class RichTextTableView extends TableView {

  constructor(
    node,
    cellMinWidth,
    view,
    HTMLAttributes = {}
  ) {

    super(
      node,
      cellMinWidth,
      view,
      HTMLAttributes
    );

    this.syncTableAttributes(node);

  }


  syncTableAttributes(node) {

    this.table.classList.add(
      "rich-text-table"
    );

    const borderWidth =
      Number(node.attrs.borderWidth);

    this.table.setAttribute(
      "data-border-width",
      [1, 2, 3, 4, 5].includes(borderWidth)
        ? String(borderWidth)
        : "1"
    );

    if (node.attrs.borderless === true) {

      this.table.setAttribute(
        "data-borderless",
        "true"
      );

    } else {

      this.table.removeAttribute(
        "data-borderless"
      );

    }

  }


  update(node) {

    const updated =
      super.update(node);

    if (updated) {
      this.syncTableAttributes(node);
    }

    return updated;

  }

}


const RichTextTable =
  Table.extend({

    addOptions() {

      return {
        ...this.parent?.(),

        View:
          RichTextTableView
      };

    },


    addAttributes() {

      return {
        ...this.parent?.(),

                borderless: {
          default: false,

          parseHTML: (element) =>
            element.getAttribute(
              "data-borderless"
            ) === "true",

          renderHTML: (attributes) => {

            if (!attributes.borderless) {
              return {};
            }

            return {
              "data-borderless": "true"
            };

          }
        },

        borderWidth: {
          default: 1,

          parseHTML: (element) => {

            const parsedWidth =
              Number(
                element.getAttribute(
                  "data-border-width"
                )
              );

            return [1, 2, 3, 4, 5]
              .includes(parsedWidth)
                ? parsedWidth
                : 1;

          },

          renderHTML: (attributes) => {

            const parsedWidth =
              Number(attributes.borderWidth);

            const borderWidth =
              [1, 2, 3, 4, 5]
                .includes(parsedWidth)
                  ? parsedWidth
                  : 1;

            return {
              "data-border-width":
                String(borderWidth)
            };

          }
        }
      };

    }

  });


export default RichTextTable;